export default "__VITE_ASSET__CFNuORSY__"